<template>
  <l-table
    ref="LTable"
    :module-name="MODULE_NAME"
    :table-columns="tableColumns"
    :table-config-options="{endpoint: `${MODULE_NAME}/advisorStudents`}"
  >
    <template #cell(dc_type)="{data}">
      {{ $langName(getDcType(data.value).name) }}
    </template>
    <template #cell(organization)="{data}">
      {{ $langName(data.value.name) }}
    </template>

    <template #cell(user)="{data}">
      {{ data.value.full_name }}
    </template>

    <template #cell(edu_lang)="{data}">
      {{ $langName(getEduLang(data.value).name) }}
    </template>

    <template #cell(quarter)="{data}">
      {{ data.value.period.admission_year + '/' +data.value.quarter }}
    </template>

    <template #cell(organization)="{data}">
      {{ $langName(data.value.name) }}
    </template>

    <template #cell(direction)="{data}">
      {{ data.value.code + ' - ' + $langName(data.value.name) }}
    </template>

    <template #cell(status)="{data}">
      <b-badge :variant="getApplyDocumentStatusColor(data.value)">
        {{ $langName(getApplyDocumentStatus(data.value).name) }}
      </b-badge>
    </template>
  </l-table>
</template>
<script>
import { onUnmounted } from '@vue/composition-api'
import { BBadge } from 'bootstrap-vue'
import store from '@/store'
import config from './config'
import studentModule from '@/store/student/index'
import LTable from '@/views/components/LTable.vue'

export default {
  components: {
    BBadge,
    LTable,
  },
  methods: {
    getDcType(id) {
      return this.$store.getters['staticModule/getDcType'](id)
    },
    getEduLang(id) {
      return this.$store.getters['staticModule/getEduLangType'](id)
    },
    getApplyDocumentStatus(id) {
      return this.$store.getters['staticModule/getApplyDocumentStatus'](id)
    },
    getApplyDocumentStatusColor(id) {
      return this.$store.getters['staticModule/getApplyDocumentStatusColor'](id)
    },
  },
  setup() {
    const MODULE_NAME = 'advisorStudent'
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, studentModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })

    return {
      MODULE_NAME,
      ...config(MODULE_NAME),
    }
  },
}
</script>
